<template>
  <span class="inline-block table-row-btns" style="white-space: nowrap;">
    <el-button
      v-for="v in outerButtons"
      :key="v.name"
      link
      @click="() => { v.action(toRaw(row)) }"
    >
      {{ v.name }}
    </el-button>

    <template v-if="insideButtons.length > 0">
      <el-dropdown trigger="hover">
        <el-button link style="margin-left: 8px;">
          更多<svg-icon icon="ep:arrow-down" />
        </el-button>

        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="ins in insideButtons"
              :key="ins.name"
              class="show-dm"
              @click="() => { ins.action(toRaw(row)) }"
            >
              {{ ins.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
  </span>
</template>

<script setup lang="ts">
import { isNull } from '@core/tools';
import { type ITableOperator, SvgIcon } from '@vue3/components';
import { PropType, ref, toRaw, watch } from 'vue';

defineOptions({ name: 'TableRowButtons' });

const props = defineProps({
  row: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({}),
  },
  buttons: {
    type: Array as PropType<Array<ITableOperator>>,
    default: () => [],
  },
});

const emit = defineEmits(['click']);

const outerButtons = ref<ITableOperator[]>([]);
const insideButtons = ref<ITableOperator[]>([]);

const initEnabledBtns = () => {
  const normalBtns = [] as ITableOperator[];
  const relationBtns = [] as ITableOperator[];
  const btns = [...toRaw(props.buttons)];

  for (const btn of btns) {
    if (isNull(btn.relationField)) {
      normalBtns.push(btn);
      continue;
    }

    switch (btn.relationFilter) {
      case 'equal':
        if (btn.relationValue === props.row[btn.relationField]) {
          relationBtns.push(btn);
        }
        break;
      case 'notEqual':
        if (btn.relationValue !== props.row[btn.relationField]) {
          relationBtns.push(btn);
        }
        break;
      case 'includes':
        if (btn.relationValue.includes(props.row[btn.relationField])) {
          relationBtns.push(btn);
        }
        break;
      default: // 默认等于
        if (btn.relationValue === props.row[btn.relationField]) {
          relationBtns.push(btn);
        }
        break;
    }
  }

  const mergedBtns = [...normalBtns, ...relationBtns];

  if (mergedBtns.length <= 3) {
    outerButtons.value = mergedBtns;
    insideButtons.value = [];
    return;
  }

  outerButtons.value = mergedBtns.slice(0, 2);
  insideButtons.value = mergedBtns.slice(2);
};

watch(
  [
    () => props.buttons,
    () => props.row,
  ],
  () => {
    initEnabledBtns();
  },
  { immediate: true },
);
</script>

<style scoped lang="scss">
:deep(.el-dropdown-menu__item) {
  display: none !important;

  &.show-dm {
    display: block !important;
  }
}

.table-row-btns {
  @apply flex items-center justify-center;
}
</style>
